const binding = { modules: {}, dataActions: {} };

    (binding.modules['business-sign-up'] = {
        c: () => require('@msdyn365-commerce-modules/business-account-management/dist/lib/modules/business-sign-up/business-sign-up'),
        $type: 'containerModule',
        da: [],
        
        iNM: true,
        ns: '@msdyn365-commerce-modules',
        n: 'business-sign-up',
        p: 'business-account-management',
        
        pdp: '',
        
        
        md: 'node_modules/@msdyn365-commerce-modules/business-account-management/dist/lib/modules/business-sign-up'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['@msdyn365-commerce-modules|business-account-management|modules|business-sign-up|business-sign-up'] = {
                c: () => require('@msdyn365-commerce-modules/business-account-management/dist/lib/modules/business-sign-up/business-sign-up.view.js'),
                cn: '@msdyn365-commerce-modules-business-account-management-business-sign-up'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };